import React, { Component } from "react";
import { translate } from "react-i18next";
import swal from 'sweetalert';

import FlatButton from "../../../components/FlatButton";

import {ic_local_offer} from 'react-icons-kit/md/ic_local_offer';
import {print} from 'react-icons-kit/fa/print';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';

import { laboratory } from "../../../assets/icons/laboratory";
import { vitalSigns } from "../../../assets/icons/vitalSigns";
import { biometrics } from "../../../assets/icons/biometrics";
import { clinic } from "../../../assets/icons/clinic";
import { incidents } from "../../../assets/icons/incidents";
import { briefcase } from "react-icons-kit/icomoon/briefcase";
import { clipboard } from "react-icons-kit/icomoon/clipboard";
import ModalReportExtraction from "../extraction/ModalReportExtraction";

import { clinicHistoryPrint, functionalCriterial, htmlTemplates, printLabel } from "../../../libs/services";
import PrintLabel from "../modals/PrintLabel";
import BiometricsVitalSigns from "../modals/BiometricsVitalSigns";
import RegisterSample from "../RegisterSample";

class Toolbar extends Component{
    constructor(props){
        super(props);

        this.action = this.action.bind(this);
        this.openReportExtraction = this.openReportExtraction.bind(this);
        this.onPrintLabel = this.onPrintLabel.bind(this);
        this.onPrintDocument = this.onPrintDocument.bind(this);
        this.goToClinicHistory = this.goToClinicHistory.bind(this);
        this.openVitalSigns = this.openVitalSigns.bind(this);
        this.openModalPrintLabel = this.openModalPrintLabel.bind(this);
        this.openSample = this.openSample.bind(this);

        this.state = {
            disableBar:true,
            auto_print_hc:{}
        }
    }

    async componentDidMount(){
        if(this.props.clinicHistory){
            var response = await functionalCriterial('AUTO_PRINT_HC');
            if(response !== undefined){
                this.setState({
                    auto_print_hc: response
                });
            }
        }
    }

    action(e){
        e.preventDefault();
    }
    
    openReportExtraction(){
        this.report_extraction.openModal(this.props.variables.donation_id);
    }

    async onPrintLabel(){
        var response;
        var hf_id = sessionStorage.getItem('health_facilities_id');

        await this.props.waiting.handleShow('Imprimiendo...');
        if(this.props.variables.labels === 'direct'){
            response = await htmlTemplates(hf_id, this.props.variables.label_key);
            if(response){
                if(response.res === 0){
                    swal('Error', 'No se ha definido ninguna etiqueta', 'error');
                }else{
                    var obj = {
                        health_facilities_id: hf_id,
                        id:this.props.variables.id,
                        file_type:this.props.variables.label_key,
                        nEtiqueta:[]
                    };

                    response = await printLabel(obj);
                    if(response){
                        if(this.props.preview_print.value === 'NO'){
                            await this.props.openFileNewWindow(response);
                        }else{
                            await this.props.directPrint(response, this.props.variables.label_key);
                        }
                    }
                }
            }
        }
        await this.props.waiting.handleClose();
    }

    async onPrintDocument(e, item){
        var hf_id = sessionStorage.getItem('health_facilities_id');

        var obj = {
            health_facilities_id: hf_id,
            id: this.props.variables.id,
            file_type: item.file_type,
            nEtiqueta:[]
        }

        await this.props.waiting.handleShow('Imprimiendo...');

        var response = await this.props.getDocumentType(obj.file_type);
      	if(response !== undefined){
			if(response.print_type === 'template'){
				await this.props.printDocumentTemplate(obj, response.print_automatically);

			}else if(response.print_type === 'external'){
				await this.props.printDocumentExternal(obj, response.print_automatically);

			}
		}
        await this.props.waiting.handleClose();
    }

    async goToClinicHistory(){
        if(this.props.variables.action_hc === 'go'){
            this.props.history.push(this.props.variables.clinic_history);
        }else{
            var response = await clinicHistoryPrint(this.props.variables.clinic_history_id, this.props.waiting);
			if(response !== undefined){
				if(this.state.auto_print_hc.value === "NO"){
                    this.props.openFileNewWindow(response);
				}else{
					this.props.directPrint(response, 'clinic_history');	
				}
			}
        }
        
    }

    openVitalSigns(e, variables){        
        this.bio_vital_signs.openModal(variables);
    }

    openModalPrintLabel(e, variables){
        
        this.print_label.openModal(
            variables.file_type, 
            variables.id,
            variables.extraction,
            variables.direct,
            variables.option,
            variables.traceability,
            variables.reference_id
        );
    }

    openSample(e, variables){
        this.sample_register.openModal(variables.donor_id, variables.id);
    }

    render(){
        const {t, smallScreen} = this.props;

        return(
            <div 
                className="col-xs-12 no-padding toolbar-container"
            >
                {this.props.samples &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={this.props.variables.flag_samples ? 'data' : 'default'}
                        action={this.openSample}
                        title="Muestras"
                        size="lg"
                        text="Muestras"
                        icon={laboratory}
                        variables={{id:this.props.variables.id, donor_id:this.props.variables.donor.id}}
                    />
                }

                {this.props.vitalSigns &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={this.props.variables.sv_status === 'COMPLETE' ? 'data' : 
                                this.props.variables.sv_status === 'INCOMPLETE' ? 'partial-data' : "no-data"}
                        action={this.openVitalSigns}
                        title="S. Vitales"
                        size="lg"
                        text="S. Vitales"
                        icon={vitalSigns}
                        variables={{...this.props.variables.donor, section:'vital_signs', type:this.props.variables.type}}
                    />
                }

                {this.props.biometrics &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={this.props.variables.bio_status === 'COMPLETE' ? 'data' : 
                                this.props.variables.bio_status === 'INCOMPLETE' ? 'partial-data' : "no-data"}
                        action={this.openVitalSigns}
                        title="Biometría Hemática"
                        size="lg"
                        text="Biometría Hemática"
                        icon={biometrics}
                        styles={{width:'6%'}}
                        variables={{...this.props.variables.donor, section:'biometrics', type:this.props.variables.type}}
                    />
                }

                {this.props.clinicHistory &&
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.clinic_history : this.props.disabled}
                        fill={(this.props.buttons !== undefined ? this.props.buttons.clinic_history : this.props.disabled) ? 'no-data' : "default"}
                        action={this.goToClinicHistory}
                        title="H. Clínica"
                        size="lg"
                        text="H. Clínica"
                        icon={clinic}
                    />
                }

                {this.props.labels &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={(this.props.disabled) ? 'no-data' : "default"}
                        action={this.openModalPrintLabel}
                        title="Etiqueta"
                        size="lg"
                        text="Etiqueta"
                        icon={ic_local_offer}
                        variables={{
                            file_type:this.props.variables.label_key,
                            id:this.props.variables.id,
                            extraction:'',
                            direct:false,
                            option:'print',
                            traceability:false
                        }}
                    />
                }
                
                {this.props.printConsent && 
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.concent : this.props.disabled}
                        fill={this.props.buttons !== undefined ? this.props.buttons.concent : this.props.disabled ? 'no-data' : "default"}
                        action={this.onPrintDocument}
                        title="Imprimir Consentimiento"
                        size="lg"
                        text="Imprimir Consentimiento"
                        icon={print}
                        styles={{width:'8%'}}
                        variables={{file_type:this.props.variables.concent_key}}
                    />
                }

                {this.props.printApheresis && 
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Imprimir Consentimiento"
                        size="lg"
                        text="Imprimir Consentimiento"
                        icon={print}
                        styles={{width:'8%'}}
                    />
                }

                {this.props.labelExtraction &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={this.props.disabled ? 'no-data' : "default"}
                        action={this.openModalPrintLabel}
                        title="Etiqueta de Extracción"
                        size="lg"
                        text="Etiqueta de Extracción"
                        icon={ic_local_offer}
                        styles={{width:'6%'}}
                        variables={this.props.variables.label.extraction}
                    />
                }

                {this.props.labelPrevBag &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Etiqueta Previa de Bolsa"
                        size="lg"
                        text="Etiqueta Previa de Bolsa"
                        icon={ic_local_offer}
                        styles={{width:'6%'}}
                    />
                }

                {this.props.notes &&
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.notes : this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Notas"
                        size="lg"
                        text="Notas"
                        icon={pencilSquareO}
                    />
                }

                {this.props.suppliesBtn &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Insumos"
                        size="lg"
                        text="Insumos"
                        icon={briefcase}
                    />
                }

                {this.props.extractionSamples &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Muestras"
                        size="lg"
                        text="Muestras"
                        icon={clipboard}
                    />
                }

                {this.props.laboratory &&
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.lab : this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Imprimir Laboratorio"
                        size="lg"
                        text="Imprimir Laboratorio"
                        icon={laboratory}
                    />
                }

                {this.props.addTest &&
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.add_test : this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Agregar Pruebas"
                        size="lg"
                        text="Agregar Pruebas"
                        icon={laboratory}
                    />
                }

                {this.props.removeIncident &&
                    <FlatButton 
                        disabled={this.props.buttons !== undefined ? this.props.buttons.remove_incident : this.props.disabled}
                        fill="no-data"
                        action={this.action}
                        title="Quitar Candado"
                        size="lg"
                        text="Quitar Candado"
                        icon={incidents}
                    />
                }

                {this.props.identityCard &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill={this.props.disabled ? 'no-data' : "default"}
                        action={this.onPrintDocument}
                        title="Ficha Identificación"
                        size="lg"
                        text="Ficha Identificación"
                        icon={print}
                        styles={{width:'7%'}}
                        variables={{file_type:this.props.variables.identification_key}}
                    />
                }

                {this.props.reportExtraction &&
                    <FlatButton 
                        disabled={this.props.disabled}
                        fill="default"
                        action={this.openReportExtraction}
                        title="Reporte"
                        size="lg"
                        text="Reporte"
                        icon={pencilSquareO}
                    />
                }

                <ModalReportExtraction {...this.props} onRef={ref => this.report_extraction = ref} />
                <BiometricsVitalSigns {...this.props} onRef={ref => this.bio_vital_signs = ref} />
                <PrintLabel {...this.props} onRef={ref => this.print_label = ref} />
                <RegisterSample 
                    {...this.props}                     
                    screen='celulas'                    
                    onRef={ref => this.sample_register = ref} 
                />
            </div>
        )
    }
}

export default translate('translations') (Toolbar);

Toolbar.defaultProps = {
    smallScreen:false,
    samples:false,
    vitalSigns:false,
    biometrics:false,
    clinicHistory:false,
    printApheresis:false,
    labels:false,
    printConsent:false,
    labelExtraction:false,
    labelPrevBag:false,
    notes:false,
    suppliesBtn:false,
    extractionSamples:false,
    laboratory:false,
    addTest:false,
    removeIncident:false,
    identityCard:false,
    variables:{}
}